var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailIllustration = function SvgEmailIllustration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "171px",
    height: "200px",
    viewBox: "0 0 171 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2FE",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA8F00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35600",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.615199537 0.00286292655 106.41786 0.00286292655 106.41786 123.325523 0.615199537 123.325523"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E6FE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C8FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E6FE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99ccfc",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "0.0683805668 0.00286292655 30.4743956 0.00286292655 30.4743956 30.4091556 0.0683805668 30.4091556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "0.0683805668 0.00286292655 27.6982244 0.00286292655 27.6982244 27.6329844 0.0683805668 27.6329844"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF3FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E2F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0.00721804511 0.208490457 125.432967 0.208490457 125.432967 68.0161943 0.00721804511 68.0161943"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD084",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD084",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.1-Webphone_new_enter_your_email_address",
    transform: "translate(-103.000000, -206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(103.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.917815,80.9926348 C148.697269,57.5003864 125.760334,40.0101904 97.554478,35.9014518 C50.9613244,29.114527 7.68839307,61.3846675 0.901468229,107.977821 C-5.88545661,154.570246 26.3839552,197.843906 72.9771088,204.630831 C119.570991,211.417756 162.843922,179.148344 169.630847,132.554462 C172.262393,114.485632 169.000471,96.9276609 161.326648,81.7913538 L160.917815,80.9926348 Z",
    id: "Fill-1",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(22.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.426721,81.5197166 L62.7130133,118.502481 L0.0006940428,81.5197166 C0.0006940428,81.4891787 0.0006940428,81.4489242 0.010410642,81.4169983 C0.0617698091,81.1824118 3.52226721,78.2938057 8.80115674,74.0046212 C8.85251591,73.9643667 8.89277039,73.9227241 8.94412955,73.8824696 C26.2618855,59.8225506 62.7130133,31.0281029 62.7130133,31.0281029 C62.7130133,31.0281029 99.1655292,59.8225506 116.481897,73.8824696 C121.842684,78.2327299 125.365645,81.1726952 125.417004,81.4169983 C125.426721,81.4489242 125.426721,81.4891787 125.426721,81.5197166",
    id: "Fill-1",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(9.716599, 0.398381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7880162,0.00244650087 L11.1243956,0.00244650087 C5.32080972,0.00244650087 0.615199537,4.70805668 0.615199537,10.5116426 L0.615199537,112.817715 C0.615199537,118.621301 5.32080972,123.325523 11.1243956,123.325523 L95.908664,123.325523 C101.71225,123.325523 106.41786,118.621301 106.41786,112.817715 L106.41786,27.6322903 L78.7880162,0.00244650087 Z",
    id: "Fill-3",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(85.660064, 0.398381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0683805668,19.8999595 C0.0683805668,25.7035454 4.77260266,30.4091556 10.5775766,30.4091556 L30.4743956,27.6329844 L2.84455176,0.00175245807 L0.0683805668,19.8999595 Z",
    id: "Fill-6",
    fillOpacity: 0.120219624,
    fill: "#022A4A",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(88.436235, 0.398381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0683805668,17.1237883 C0.0683805668,22.9273742 4.77260266,27.6329844 10.5775766,27.6329844 L27.6982244,27.6329844 L0.0683805668,0.00175245807 L0.0683805668,17.1237883 Z",
    id: "Fill-9",
    fill: "url(#linearGradient-10)",
    mask: "url(#mask-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 81.308589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.433245,0.208490457 L125.433245,60.3736726 C125.433245,64.579572 121.996345,68.0164719 117.790445,68.0164719 L7.62919607,68.0164719 C3.4232967,68.0164719 0.00721804511,64.579572 0.00721804511,60.3736726 L0.00721804511,0.208490457 L62.7195373,37.1857027 L125.433245,0.208490457 Z",
    id: "Fill-12",
    fill: "url(#linearGradient-13)",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.31336,146.930335 L74.610989,111.481405 L62.7206478,118.494014 L50.8275304,111.481405 L2.11544245,146.927559 C3.50491614,148.396154 5.4551764,149.324783 7.62891845,149.324783 L117.791556,149.324783 C119.96391,149.324783 121.918334,148.397542 123.31336,146.930335",
    id: "Fill-15",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7233314,81.4528109 L34.7099132,81.4528109 C33.0442105,81.4528109 31.6936032,82.8034182 31.6936032,84.4691209 C31.6936032,86.1348236 33.0442105,87.4854309 34.7099132,87.4854309 L90.7233314,87.4854309 C92.3890341,87.4854309 93.7396414,86.1348236 93.7396414,84.4691209 C93.7396414,82.8034182 92.3890341,81.4528109 90.7233314,81.4528109",
    id: "Fill-17",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7099132,43.084598 L90.7233314,43.084598 C92.3890341,43.084598 93.7396414,41.7339907 93.7396414,40.068288 C93.7396414,38.4025853 92.3890341,37.051978 90.7233314,37.051978 L34.7099132,37.051978 C33.0442105,37.051978 31.6936032,38.4025853 31.6936032,40.068288 C31.6936032,41.7339907 33.0442105,43.084598 34.7099132,43.084598",
    id: "Fill-19",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7233314,52.0774494 L34.7099132,52.0774494 C33.0442105,52.0774494 31.6936032,53.4280567 31.6936032,55.0937594 C31.6936032,56.7594621 33.0442105,58.1100694 34.7099132,58.1100694 L90.7233314,58.1100694 C92.3890341,58.1100694 93.7396414,56.7594621 93.7396414,55.0937594 C93.7396414,53.4280567 92.3890341,52.0774494 90.7233314,52.0774494",
    id: "Fill-21",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7233314,66.6527646 L34.7099132,66.6527646 C33.0442105,66.6527646 31.6936032,68.0033719 31.6936032,69.6690746 C31.6936032,71.3347773 33.0442105,72.6853846 34.7099132,72.6853846 L90.7233314,72.6853846 C92.3890341,72.6853846 93.7396414,71.3347773 93.7396414,69.6690746 C93.7396414,68.0033719 92.3890341,66.6527646 90.7233314,66.6527646",
    id: "Fill-23",
    fill: "url(#linearGradient-15)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailIllustration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email_illustration.7d4d19e0.svg";
export { ForwardRef as ReactComponent };